
export { CollectionName } from "/codebuild/output/src2674723067/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"